/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Event/view.blocks to change it.
import LoadMoreAction from './LoadMoreAction/index'
import React from 'react'
import Types from './Types/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Event({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Event.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadMoreAction
  viewPath={`${viewPath}/LoadMoreAction`}
/>
<Types
  viewPath={`${viewPath}/Types`}
/>
</div>
{children}
</React.Fragment>)
}